import { CopyTextButton } from '../shared/CopyTextButton';

// Hidden until the row is hovered; the row must carry the `group/name` class.
const HOVER_REVEAL_CLASS = 'opacity-0 group-hover/name:opacity-100';

interface CopyPatientNameButtonProps {
    name: string;
}

export function CopyPatientNameButton({ name }: CopyPatientNameButtonProps) {
    return (
        <CopyTextButton text={name} label="Copy patient name" idleClassName={HOVER_REVEAL_CLASS} />
    );
}
